import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/apiService';
import './EmailVerifyPage.css';

const EmailVerifyPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link. No token provided.');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await api.get(`/configuration/verify-email?token=${token}`);
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully!');
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Verification failed. The link may have expired.');
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="email-verify-page">
      <div className="email-verify-card">
        {status === 'verifying' && (
          <>
            <div className="verify-icon verifying">⏳</div>
            <h2>Verifying your email...</h2>
            <p>Please wait while we verify your email address.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="verify-icon success">✓</div>
            <h2>Email Verified!</h2>
            <p>{message}</p>
            <button className="verify-btn" onClick={() => navigate('/')}>
              Go to Homepage
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="verify-icon error">✕</div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <button className="verify-btn" onClick={() => navigate('/')}>
              Go to Homepage
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerifyPage;
